module.exports = __webpack_public_path__ + "newsletter-CTA-on-homepage-4a5f435871d949f0244d.png";